import type { Colors, DefaultTheme } from 'styled-components';
import { darkColors, mapDarkTheme } from './DarkTheme';

const colors: Colors = {
  ...darkColors,
  primary: {
    lighten: '#97f0e1',
    default: '#6aead4',
    dim: 'rgba(106,234,212,0.4)',
    mute: 'rgba(106,234,212,0.1)',
  },
  gray: {
    '100': '#ffe',
    '000': '#010101',
    '010': '#080808',
    main: '#181a1d',
    '020': '#252729',
    '030': '#333536',
    '040': '#414342',
    '050': '#484a48',
    '060': '#515351',
    '070': '#61635f',
    '080': '#8b8c85',
    '090': '#abaca2',
  },
  green: {
    lighten: '#a8ffae',
    default: '#75ff7e',
    dim: 'rgba(117,255,126,0.4)',
    mute: 'rgba(117,255,126,0.1)',
  },
  red: {
    lighten: '#ff7163',
    default: '#ff4330',
    dim: 'rgba(255,67,48,0.4)',
    mute: 'rgba(255,67,48,0.1)',
  },
  yellow: {
    lighten: '#f7ba54',
    default: '#f5a623',
    dim: 'rgba(245,166,35,0.4)',
    mute: 'rgba(245,166,35,0.1)',
  },
  orange: {
    lighten: '#f7ba54',
    default: '#f5a623',
    dim: 'rgba(245,166,35,0.4)',
    mute: 'rgba(245,166,35,0.1)',
  },
  blue: {
    lighten: '#61a8f0',
    default: '#338EEB',
    dim: 'rgba(51,142,235,0.4)',
    mute: 'rgba(51,142,235,0.1)',
  },
  purple: {
    lighten: '#a778e2',
    default: '#8B4ED9',
  },
  white: {
    default: '#ffffff',
    dim: 'rgba(255,255,255,0.4)',
    mute: 'rgba(255,255,255,0.1)',
  },
  black: {
    default: '#000000',
    dim: 'rgba(0,0,0,0.4)',
    mute: 'rgba(0,0,0,0.1)',
  },
};

export const DarkCopperTheme: DefaultTheme = mapDarkTheme(colors, {
  name: 'DarkCu',

  colorTextDefaultButton: '#ffffff',
  colorTextDefaultButtonHover: '#ffffff',
  colorTextDefaultButtonFocus: '#ffffff',
  colorTextDefaultButtonActive: '#ffffff',
  colorTextDefaultButtonDisabled: 'rgba(255,255,255,0.5)',

  colorTextPositiveButton: '#000000',
  colorTextPositiveButtonHover: '#000000',
  colorTextPositiveButtonFocus: '#000000',
  colorTextPositiveButtonActive: '#000000',
  colorTextPositiveButtonDisabled: 'rgba(0,0,0,0.5)',

  colorTextNegativeButton: '#000000',
  colorTextNegativeButtonHover: '#000000',
  colorTextNegativeButtonFocus: '#000000',
  colorTextNegativeButtonActive: '#000000',
  colorTextNegativeButtonDisabled: 'rgba(0,0,0,0.5)',

  colorTextWarningButton: '#000000',
  colorTextWarningButtonHover: '#000000',
  colorTextWarningButtonFocus: '#000000',
  colorTextWarningButtonActive: '#000000',
  colorTextWarningButtonDisabled: 'rgba(0,0,0,0.5)',

  colorTextPrimaryButton: '#000000',
  colorTextPrimaryButtonHover: '#000000',
  colorTextPrimaryButtonFocus: '#000000',
  colorTextPrimaryButtonActive: '#000000',
  colorTextPrimaryButtonDisabled: 'rgba(0,0,0,0.5)',

  colorTextMutedButton: '#ffffff',
  colorTextMutedButtonHover: '#ffffff',
  colorTextMutedButtonFocus: '#ffffff',
  colorTextMutedButtonActive: '#ffffff',
  colorTextMutedButtonDisabled: 'rgba(255,255,255,0.5)',
});
